const OPEN_WORKSPACES_HOME_IDENTIFIER = 'workspaces',
      OPEN_WORKSPACES_HOME_URL = 'workspaces',
      USER_ONBOARDING_PAGE_URL = 'onboarding/user',
      TEAM_ONBOARDING_PAGE_URL = 'onboarding/team',
      USER_ONBOARDING_IDENTIFIER = 'onboarding.user',
      TEAM_ONBOARDING_IDENTIFIER = 'onboarding.team',
      HOME_IDENTIFIER = 'home',
      DEFAULT_HOME_IDENTIFIER = 'home.default',
      DEFAULT_HOME_URL = '/',
      OPEN_BOOTCAMP_IDENTIFIER = 'bootcamp',
      OPEN_BOOTCAMP_URL = 'bootcamp',
      CREATING_TEAM_LOADER = 'creatingTeamLoader',
      OPEN_CREATE_NEW_IDENTIFIER = 'build.new',
      TRIAL_ACTIVATION_PAGE_URL = 'onboarding/trial',
      TRIAL_ACTIVATION_IDENTIFIER = 'onboarding.trial';

export {
  OPEN_WORKSPACES_HOME_IDENTIFIER,
  OPEN_WORKSPACES_HOME_URL,
  USER_ONBOARDING_PAGE_URL,
  TEAM_ONBOARDING_PAGE_URL,
  USER_ONBOARDING_IDENTIFIER,
  TEAM_ONBOARDING_IDENTIFIER,
  HOME_IDENTIFIER,
  DEFAULT_HOME_IDENTIFIER,
  DEFAULT_HOME_URL,
  OPEN_BOOTCAMP_IDENTIFIER,
  OPEN_BOOTCAMP_URL,
  CREATING_TEAM_LOADER,
  OPEN_CREATE_NEW_IDENTIFIER,
  TRIAL_ACTIVATION_PAGE_URL,
  TRIAL_ACTIVATION_IDENTIFIER
};
